module.exports = __webpack_public_path__ + "img/question-mark-red.e25e9f9c.svg";